"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stripDiascritics_1 = __importDefault(require("../stripDiascritics"));
var trimString = function (str) { return str.replace(/^\s+|\s+$/g, ""); };
// Filter inspired by the original react-select filter
// https://github.com/JedWatson/react-select/blob/b0411ff46bc1ecf45d9bca4fb58fbce1e57f847c/packages/react-select/src/filters.js
function countryFilter(option, rawInput) {
    if (rawInput) {
        var input_1 = stripDiascritics_1.default(trimString(rawInput.toLowerCase()));
        var candidate = stripDiascritics_1.default(trimString(option.label.toLowerCase()));
        var _a = candidate.split(" – "), code = _a[0], name_1 = _a[1];
        // If the user types only one character, it should filter
        // by country code only to keep their experience similar to previous state.
        if (input_1.length <= 1) {
            return code.startsWith(input_1);
            // Otherwise we filter by start of words and by countryCode
        }
        else {
            var names = name_1.split(/ |\u00A0/);
            return names.some(function (name) { return name.startsWith(input_1); }) || code.indexOf(input_1) !== -1;
        }
    }
    return true;
}
exports.default = countryFilter;
;
